/**
 * Показ отложенных файлов и «скрепка» рядом с полем ввода.
 * Сам набор ведёт usePendingFiles.
 */

import { Paperclip, X } from "lucide-react";
import { useRef } from "react";

import { IconButton } from "./IconButton";
import type { AttachOptions } from "./usePendingFiles";

export function PendingFiles({
  files,
  label,
  disabled = false,
  onRemove,
}: {
  files: File[];
  /** Заголовок списка для чтения с экрана. */
  label: string;
  disabled?: boolean;
  onRemove: (index: number) => void;
}) {
  if (files.length === 0) return null;
  return (
    <ul className="flex flex-wrap gap-1.5" aria-label={label}>
      {files.map((file, index) => (
        <li
          key={`${file.name}-${String(index)}`}
          className="flex max-w-60 items-center gap-1 rounded-sm bg-sunken py-0.5 pr-0.5 pl-2 text-[11px] text-muted"
        >
          <span className="truncate">{file.name}</span>
          <IconButton
            icon={X}
            label={`Убрать ${file.name}`}
            size="sm"
            disabled={disabled}
            onClick={() => onRemove(index)}
          />
        </li>
      ))}
    </ul>
  );
}

/** Поле выбора файла скрыто: системное оформление не совпадает
 *  ни с одной кнопкой макета. */
export function AttachButton({
  attach,
  disabled = false,
  label = "Прикрепить файл",
  onPick,
}: {
  attach: AttachOptions;
  disabled?: boolean;
  label?: string;
  onPick: (files: FileList | null) => void;
}) {
  const input = useRef<HTMLInputElement>(null);
  return (
    <>
      <input
        ref={input}
        type="file"
        multiple
        className="hidden"
        aria-hidden
        tabIndex={-1}
        accept={attach.accept}
        onChange={(event) => {
          onPick(event.target.files);
          // Тот же файл выбирают повторно, убрав его по ошибке: без сброса
          // значения change не повторится и ничего не произойдёт.
          event.target.value = "";
        }}
      />
      <IconButton
        icon={Paperclip}
        label={label}
        size="sm"
        disabled={disabled}
        onClick={() => input.current?.click()}
      />
    </>
  );
}
